const Pin = ({x, y}) => (
    <span
        className="location-position icon icon-pin"
        style={{left: `${x}%`, top: `${y}%`}}
    />
);

export default Pin;
